import { ChargeSummaryReportActionDispatch, ChargeSummaryReportReducerDispatch, ChargeSummaryReportReduxTypes, CreateChargeSummaryReportReduxState } from "./types"

const CHARGE_SUMMARY_REPORT_INITIAL_STATE = {
    data: {},
    loading: false,
    error: null
}

const CreateChargeSummaryReportReducer = (state: CreateChargeSummaryReportReduxState = CHARGE_SUMMARY_REPORT_INITIAL_STATE, action: ChargeSummaryReportReducerDispatch) => {
    switch (action.type) {
        case ChargeSummaryReportReduxTypes.CHARGE_SUMMARY_REPORT:
            return {
                ...state,
                loading: true
            }
        case ChargeSummaryReportReduxTypes.CHARGE_SUMMARY_REPORT_SUCCESS:
            return {
                ...state,
                data: action.payload.data,
                loading: false
            }
        case ChargeSummaryReportReduxTypes.CHARGE_SUMMARY_REPORT_ERROR:

            return {
                ...state,
                error: action.payload.error,
                loading: false
            }
        default:
            return { ...state }
    }
}

export { CreateChargeSummaryReportReducer }